interface ThreeDStockContentImageLensLoadingOverlayProps {
  loadingText?: string;
}

function ThreeDStockContentImageLensLoadingOverlay({
  loadingText
}: ThreeDStockContentImageLensLoadingOverlayProps) {
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded bg-black/40 backdrop-blur-[2px]">
      <svg
        className="h-8 w-8 animate-spin text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
      {loadingText && (
        <span className="text-sm font-medium text-white/90">{loadingText}</span>
      )}
    </div>
  );
}

export default ThreeDStockContentImageLensLoadingOverlay;
